import countries from 'i18n-iso-countries';

import { TestStatus, ReleaseStatus, VersionStatus } from 'common/contracts';

export enum ESwitchOptions {
  TEST = 'Test',
  RELEASE = 'Release'
}

export const SWITCH_OPTIONS = [
  { value: ESwitchOptions.TEST },
  { value: ESwitchOptions.RELEASE }
];

export const TEST_STATUS_TO_COLOR_MAP: Record<TestStatus, string> = {
  [TestStatus.READY]: 'text-green-500',
  [TestStatus.NEW_VERSION_AVAILABLE]: 'text-red-500',
  [TestStatus.IN_PROGRESS]: 'text-green-500'
};

export const RELEASE_STATUS_TO_COLOR_MAP: Record<ReleaseStatus, string> = {
  [ReleaseStatus.BLOCKED]: 'text-red-500',
  [ReleaseStatus.READY]: 'text-blue-500',
  [ReleaseStatus.IN_PROGRESS]: 'text-green-500',
  [ReleaseStatus.NEW_VERSION_AVAILABLE]: 'text-red-500'
};

export function getCountriesOptions() {
  const countriesList = countries.getNames('en');
  const countriesOptions = Object.entries(countriesList).map(
    ([code, name]) => ({
      value: code,
      label: name
    })
  );

  return countriesOptions;
}

export function getVersionNextStatus(
  isAllCountriesSelected: boolean,
  isHardRelease: boolean
) {
  if (isAllCountriesSelected) {
    return isHardRelease ? VersionStatus.RELEASED : VersionStatus.SOFT_RELEASE;
  }

  return VersionStatus.TESTING;
}
